import CONFIG from "./../config.json";
import {cacheGetCacheTime} from "./cache.js";
import {Log} from "./log.js";

const AUTHORS_FETCH_NUMBER = 20;
let authorsCards = [];
let authorsFetching = false;
let authorsToResolve = [];
let authorsAllDownloaded = false;
let authorsFlushCache = false;
let authorsCursor = null;



// only for testing new possibilities
function _authorGetWebLink(author)
{
    // testing for the Restaurant el Molí author
    //if (author.id === "Y2hlemNoYXJwZW50aWVyQGdtYWlsLmNvbQ==")
//    {
//        return("www.yuppiya.com/ca/list.html?id=Y2hlemNoYXJwZW50aWVyQGdtYWlsLmNvbQ==");
//    }
    return(author.webLink);
}

function _authorHasText(value)
{
    return (typeof value === "string" && value.trim() !== "");
}

function _authorGetHref(authorWebLink)
{
    if (_authorHasText(authorWebLink) === false)
    {
        return null;
    }

    if (authorWebLink.startsWith("http://") || authorWebLink.startsWith("https://"))
    {
        return authorWebLink;
    }
    return "http://" + authorWebLink;
}

function _authorGetEntry(text, href)
{
    if (_authorHasText(text) === false)
    {
        return "";
    }

    if (href === null)
    {
        return "<div class='authorAnchors'>" + text + "</div>";
    }
    return "<a class='authorAnchors' href='" + href + "'>" + text + "</a>";
}

function authorsGetCard(author)
{
    let authorWebLink = _authorGetWebLink(author);
    let authorHref = _authorGetHref(authorWebLink);
    //let authorRef = "/list/" + + postersEscapeSpacesAndApostrophes(author.name) + ".html?id=" + author.id ;
    let authorTemplate =
            "<div class='authorWrapper'>" +
            "<img class='authorImage' src='" + author.imageUrl + "'>" +
            "<div class='authorLinks'>" +
            _authorGetEntry(author.name, authorHref) +
            _authorGetEntry(author.activity, authorHref) +
            "</div>" +
            "</div>";
    return(authorTemplate);
}

function authorsGetAnonymous()
{
    let anonimous =
            {imageUrl: `${CONFIG.posters_api_url}/images/anonymous_v2.png`,
                authorWebLink: 'cartells.yuppiya.com',
                name: 'Anonymous',
                activity: ''};

    return(anonimous);
}

function authorsGet(id)
{
    if (authorsCards !== null)
    {
        for (const authorCard of authorsCards)
        {
            if (authorCard.id === id)
            {
                return authorCard;
            }
        }
    }
    return(undefined);
}

function authorsAppendUniqueCards(list)
{
    let appended = 0;
    if (Array.isArray(list) === false)
    {
        return appended;
    }

    list.forEach((authorCard) =>
    {
        if ((authorCard !== undefined) && (authorsGet(authorCard.id) === undefined))
        {
            authorsCards.push(authorCard);
            appended++;
        }
    });

    return appended;
}

function authorsFetchFromServer()
{
    // resource ------------------------------------------------------------
    let resource = `${CONFIG.posters_api_url}/resource/profile/public/batch`;
    if (authorsCursor !== null)
        resource += "?cursor=" + authorsCursor + "&";
    else
        resource += "?";
    resource += "flush=" + authorsFlushCache;

    let cacheTime = cacheGetCacheTime();
    if ((cacheTime !== null) && (cacheTime !== ""))
    {
        resource += "&cacheTime=" + cacheTime;
    }

    // fetch ---------------------------------------------------------------
    // authors are cached by the browser 
    fetch(resource)
            .then(response => response.json())
            .then(aux =>
            {
                const previousCursor = authorsCursor;
                const appendedCards = authorsAppendUniqueCards(aux.list);

                // Only stop when the backend stops sending a cursor.
                // A visible batch can be shorter than AUTHORS_FETCH_NUMBER
                // and still have more results available in the next cursor.
                authorsCursor = aux.cursor;
                const cursorIsStalled =
                        (authorsCursor !== null) &&
                        (authorsCursor === previousCursor) &&
                        (appendedCards === 0);
                if (!aux.cursor || cursorIsStalled)
                {
                    authorsAllDownloaded = true;
                    authorsCursor = null;
                }
                //                    
                while (authorsToResolve.length > 0)
                {
                    let au = authorsToResolve.shift();
                    let author = authorsGet(au.id);
                    if (author === undefined)
                    {
                        // we need to flush all caches
                        if (authorsAllDownloaded === true)
                        {
                            author = authorsGetAnonymous();
//                            if (authorsFlushCache === false)
//                            {
//                                authorsFlushCache = true;
//                                authorsAllDownloaded = false;
//                                //authorsCards.length = 0;
//                                authorsCursor = null;
//                                // not fetch yet pushed to the end of the array
//                                authorsToResolve.push(au);
//                                authorsFetchFromServer();
//                                break;
//                            } else
//                            {
//                                au.reject("No s'ha trobat l'autor " + au.id);
//                            }
                        } else
                        {
                            // not fetch yet pushed to the end of the array
                            authorsToResolve.push(au);
                            authorsFetchFromServer();
                            break;
                        }

                    }
                    //
                    au.resolve(author);
                }
            })
            .catch(error =>
            {
                Log.print('Fetch authors error: ' + error);
            })
            .finally(() =>
            {
                authorsFetching = false;
            });
}

function authorsFetch()
{
    if (authorsFetching === false)
    {
        authorsFetching = true;
        authorsFetchFromServer();
    }
}


function authorsfetchCard(id)
{
    return new Promise(function (resolve, reject)
    {
        let author = authorsGet(id);
        if (author === undefined)
        {
            let aux = {id, resolve, reject};
            authorsToResolve.push(aux);
            if (authorsFetching === false)
            {
                authorsFetch();
            }
        } else
        {
            resolve(author);
        }


    });
}

export {authorsGetCard, authorsfetchCard};
